import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CartActions } from '@spartacus/cart/base/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { KnBrDraftOrdersCommentsAdapter } from '../../connectors/kn-br-draft-orders-comments.adapter';
import {
  KnBrDraftOrderCommentsActions,
  KnBrDraftOrderCommentsActionTypes,
  KnBrDraftOrderCommentsCreateFailure,
  KnBrDraftOrderCommentsLoad,
  KnBrDraftOrderCommentsLoadFailure,
  KnBrDraftOrderCommentsLoadSuccess,
  KnBrDraftOrderCommentsUpdateFailure,
} from '../actions/kn-br-draft-orders-comments.action';

@Injectable()
export class KnBrDraftOrdersCommentsEffects {
  //@Effect()
  loadDraftOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrDraftOrderCommentsActionTypes.KnBrDraftOrderCommentsLoadAction),
      mergeMap((action) =>
        this.DraftOrdersCommentsAdapter.get(action.entryNumber).pipe(
          map((data: any) => {
            return new KnBrDraftOrderCommentsLoadSuccess(data);
          }),
          catchError((error: Error) => {
            return of(new KnBrDraftOrderCommentsLoadFailure(error));
          })
        )
      )
    )
  );

  //@Effect()
  createDraftOrderComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrDraftOrderCommentsActionTypes.KnBrDraftOrderCommentsCreateAction),
      mergeMap((action) =>
        this.DraftOrdersCommentsAdapter.create(action.payload).pipe(
          mergeMap(() => [
            new KnBrDraftOrderCommentsLoad(action.payload.entryNumber),
            new CartActions.ResetCartDetails(),
          ]),
          catchError((error: Error) => {
            return of(new KnBrDraftOrderCommentsCreateFailure(error));
          })
        )
      )
    )
  );
  //@Effect({ dispatch: false })
  createSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrDraftOrderCommentsActionTypes.KnBrDraftOrderCommentsCreateSuccessAction),
        map(() => new KnBrDraftOrderCommentsLoad(0))
      ),
    { dispatch: false }
  );

  //@Effect({ dispatch: false })
  createFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrDraftOrderCommentsActionTypes.KnBrDraftOrderCommentsCreateFailureAction),
        map(() => {
          // Todo
          return;
        })
      ),
    { dispatch: false }
  );

  //@Effect()
  updateDraftOrderComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrDraftOrderCommentsActionTypes.KnBrDraftOrderCommentsUpdateAction),
      mergeMap((action) =>
        this.DraftOrdersCommentsAdapter.update(action.payload).pipe(
          map(() => new KnBrDraftOrderCommentsLoad(action.payload.entryNumber)),
          catchError((error: Error) => {
            return of(new KnBrDraftOrderCommentsUpdateFailure(error));
          })
        )
      )
    )
  );

  //@Effect()
  deleteDraftOrderComment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrDraftOrderCommentsActionTypes.KnBrDraftOrderCommentsDeleteAction),
      mergeMap((action) =>
        this.DraftOrdersCommentsAdapter.delete(action.payload).pipe(
          mergeMap(() => [
            new KnBrDraftOrderCommentsLoad(action.payload.entryNumber),
            new CartActions.ResetCartDetails(),
          ]),
          catchError((error: Error) => {
            return of(new KnBrDraftOrderCommentsUpdateFailure(error));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions<KnBrDraftOrderCommentsActions>,
    private DraftOrdersCommentsAdapter: KnBrDraftOrdersCommentsAdapter
  ) {}
}
